// src/store/actions.js
export const setBusinessCaseInputs = payload => ({
  type: 'SET_BUSINESS_CASE_INPUTS',
  payload
});

export const setBusinessCaseLoading = isLoading => ({
  type: 'SET_BUSINESS_CASE_LOADING',
  payload: isLoading
});

export const setBusinessCaseError = error => ({
  type: 'SET_BUSINESS_CASE_ERROR',
  payload: error
});

export const setBusinessCaseResult = payload => ({
  // payload: { current, previous }
  type: 'SET_BUSINESS_CASE_RESULT',
  payload
});
